/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.redeemCoupon

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.redeemCoupon.RedeemCouponsApi
import features.redeemCoupon.models.CouponRedemptionResponseModel
import features.redeemCoupon.serializeRedeemCouponsState
import features.redeemCoupon.models.RedeemCouponRequest

import kotlinx.serialization.decodeFromString

/**
 * Redeem a coupon. Coupons are created after an offer has been redeemed.  [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("RedeemCouponsApi")
class RedeemCouponsApiJs {

    /**
     * Redeem a coupon. Coupons are created after an offer has been redeemed. 
     */


    
    fun redeemCoupon(overrideHeaders: String?,
serializedRedeemCouponRequest: String): Promise<String?>  {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

        return GlobalScope.promise {
            val result = RedeemCouponsApi().redeemCoupon(
            overrideHeaders = decodedOverrideHeaders,
                redeemCouponRequest = Json.decodeFromString(
                    serializedRedeemCouponRequest
                )
            ).toJsonResult<CouponRedemptionResponseModel>()

           return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    fun observeRedeemCouponsState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        RedeemCouponsApi().redeemCouponsState.serializeRedeemCouponsState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
